__turbopack_context__.v({
  "admin-bg-danger": "PagePreloader-module-scss-module__SnoWPa__admin-bg-danger",
  "admin-bg-info": "PagePreloader-module-scss-module__SnoWPa__admin-bg-info",
  "admin-bg-primary": "PagePreloader-module-scss-module__SnoWPa__admin-bg-primary",
  "admin-bg-secondary": "PagePreloader-module-scss-module__SnoWPa__admin-bg-secondary",
  "admin-bg-success": "PagePreloader-module-scss-module__SnoWPa__admin-bg-success",
  "admin-bg-warning": "PagePreloader-module-scss-module__SnoWPa__admin-bg-warning",
  "admin-border": "PagePreloader-module-scss-module__SnoWPa__admin-border",
  "admin-border-dark": "PagePreloader-module-scss-module__SnoWPa__admin-border-dark",
  "admin-border-light": "PagePreloader-module-scss-module__SnoWPa__admin-border-light",
  "admin-rounded": "PagePreloader-module-scss-module__SnoWPa__admin-rounded",
  "admin-rounded-full": "PagePreloader-module-scss-module__SnoWPa__admin-rounded-full",
  "admin-rounded-lg": "PagePreloader-module-scss-module__SnoWPa__admin-rounded-lg",
  "admin-rounded-md": "PagePreloader-module-scss-module__SnoWPa__admin-rounded-md",
  "admin-rounded-sm": "PagePreloader-module-scss-module__SnoWPa__admin-rounded-sm",
  "admin-shadow-lg": "PagePreloader-module-scss-module__SnoWPa__admin-shadow-lg",
  "admin-shadow-md": "PagePreloader-module-scss-module__SnoWPa__admin-shadow-md",
  "admin-shadow-sm": "PagePreloader-module-scss-module__SnoWPa__admin-shadow-sm",
  "admin-sr-only": "PagePreloader-module-scss-module__SnoWPa__admin-sr-only",
  "admin-text-light": "PagePreloader-module-scss-module__SnoWPa__admin-text-light",
  "admin-text-muted": "PagePreloader-module-scss-module__SnoWPa__admin-text-muted",
  "admin-text-primary": "PagePreloader-module-scss-module__SnoWPa__admin-text-primary",
  "admin-text-secondary": "PagePreloader-module-scss-module__SnoWPa__admin-text-secondary",
  "preloader": "PagePreloader-module-scss-module__SnoWPa__preloader",
  "preloader__logo": "PagePreloader-module-scss-module__SnoWPa__preloader__logo",
});
